<template>
  <div class="overlay" :style="{height: isShow?'100%':'0%'}">
    <div class="btn-group" :style="{display: isShow?'':'none'}">
      <div class="btn-group-item" @click="onDownloadButtonClick">
        <i class="el-icon-download btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('download') }}</span>
      </div>
      <div class="btn-group-item" @click="onPrintButtonClick()">
        <i class="el-icon-printer btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('print') }}</span>
      </div>
      <div v-if="contractDetail.status === CONTRACT_STATUS.DRAFT"
           class="btn-group-item"
           @click="onSaveDraftButtonClick()">
        <i class="el-icon-document btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('saveDraft') }}</span>
      </div>
      <div class="btn-group-item" @click="onSaveContractButtonClick(contractDetail)">
        <i class="el-icon-document-checked btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('saveContract') }}</span>
      </div>
      <div class="btn-group-item" @click="closePreview()">
        <i class="el-icon-close btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('close') }}</span>
      </div>
    </div>
    <document-container-component
      :hotel="hotel"
      :contract-detail="contractDetail"
      :supplement-type-list="supplementTypeList"
      :company-data="companyData">
    </document-container-component>
    <iframe width="0" height="0" id="printIframe" name="printIframe"></iframe>
  </div>
</template>
<script>
import i18nMessages from '@/translations/Contract/components/PreviewContract.i18n'
import { forceDownloadFileUrl } from '@/helpers'
import { get } from 'lodash'
import ContractApi from '@/api/contract-api'
import { prepareDocumentData } from '@/services/contract-service'
import DocumentContainerComponent from '@/views/Contract/components/PreviewContract/DocumentContainerComponent'
import { CONTRACT_STATUS } from '@/configs/constant'

export default {
  name: 'PreviewContract',
  components: {
    DocumentContainerComponent
  },
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    contractDetail: {
      type: Object,
      default: () => {
        return {
          id: '',
          hotelId: '',
          refCode: '',
          startDate: '',
          endDate: '',
          salePerson: {},
          internalNote: '',
          agent: {},
          status: CONTRACT_STATUS.DRAFT,
          rateCodeList: [],
          allotmentList: [],
          cutOffDateList: [],
          promotionList: [],
          supplementList: [],
          transferList: [],
          termsOfPaymentList: [],
          remarkList: [],
          termAndCondition: {
            updatedAt: '',
            dataList: []
          }
        }
      }
    },
    supplementTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    companyData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      isShow: false,
      CONTRACT_STATUS: CONTRACT_STATUS
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShow = newValue
    }
  },
  methods: {
    getCompanyLogo: function () {
      const logoUrl = get(this.companyData, 'logoUrl', '')

      return logoUrl
    },
    onDownloadButtonClick: async function () {
      try {
        this.$emit('onDownloadStart')

        const contractId = get(this.contractDetail, 'id', 'new-contract')
        const refCode = this.contractDetail.refCode.toLowerCase()
        const fileName = `contract-${refCode}.docx`
        const data = prepareDocumentData(this.contractDetail)
        const documentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

        const documentResult = await ContractApi.generateDocument(contractId, data, documentType)
        const documentData = `data:${documentType}; base64, ${documentResult}`
        forceDownloadFileUrl(documentData, fileName)
      } catch (err) {
        this.$emit('onDownloadError', err.message)
      }

      this.$emit('onDownloadSuccess')
    },
    onPrintButtonClick: function () {
      const documentContent = document.getElementById('contract-document').innerHTML
      const iframe = window.frames['printIframe']
      iframe.document.write('<html><head><title>my div</title>')
      iframe.document.write('<style> body {font-family: "Arial"; font-size: 14px}</style>')
      iframe.document.write('</head><body onload="window.print()">')
      iframe.document.write(documentContent)
      iframe.document.write('</body></html>')
      iframe.document.close()
    },
    onSaveDraftButtonClick: function () {
      this.isShow = false
      this.$emit('onSaveDraft')
    },
    onSaveContractButtonClick: function (contractDetail) {
      this.isShow = false
      this.$emit('onSavePublish', contractDetail.id)
    },
    closePreview: function () {
      this.isShow = false
      this.$emit('onClose')
    }
  }
}
</script>
<style scope>
  .overlay {
    width: 100%;
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    overflow-x: hidden;
    transition: 0.5s;
    height: 0;
  }

  .overlay-content {
    position: relative;
    top: 10%;
    margin-top: 30px;
    overflow-y: scroll;
    font-size: 18px;
    width: calc(100% - 200px);
    padding-left: 100px;
    padding-right: 100px;
    padding-bottom: 100px;
  }

  .overlay a {
    padding: 8px;
    text-decoration: none;
    font-size: 36px;
    color: #818181;
    display: block;
    transition: 0.3s;
  }

  .overlay a:hover, .overlay a:focus {
    color: #f1f1f1;
  }

  .overlay .btn-group {
    position: fixed;
    top: 0px;
    right: 45px;
    width: 420px;
    height: 80px;
    text-align: center;
    z-index: 10;
  }
  .btn-group-item {
    float: left;
    background-color: rgba(53, 53, 53, 0.8);
    height: 70px;
    width: 80px;
    margin-left: 3px;
    color: #ffffff;
    text-align: center;
    vertical-align: bottom;
    padding-top: 10px;
    cursor: pointer;
  }

  .btn-group-item:hover {
    background-color: rgba(102, 170, 241, 0.8);
  }
  .btn-group-item-font-size {
    font-size: 9px;
    font-weight: bold;
  }
  .btn-group-item-icon-size {
    font-size: 40px;
  }
</style>
